import React, { useMemo } from 'react';
import { Box } from '@mui/material';

const LiveFeedViewer = ({ cameraId, apiBase }) => {
  const src = useMemo(() => {
    if (!cameraId) return null;
    return `${apiBase}/live-video-feed/${cameraId}/?t=${Date.now()}`;
  }, [apiBase, cameraId]);

  if (!src) {
    return null;
  }

  return (
    <Box
      component="img"
      src={src}
      alt="Live camera feed"
      sx={{
        width: '100%',
        aspectRatio: '16 / 9',
        objectFit: 'cover',
        display: 'block',
        backgroundColor: 'black',
        border: '1px solid rgba(15, 23, 42, 0.15)',
        borderRadius: 2,
      }}
    />
  );
};

export default LiveFeedViewer;
